import React from 'react';
import SelexRiskNavbar from "./CommonC/SelexRiskNavbar";

function SelexHybrid() {
  return (
    <div>
       <SelexRiskNavbar />

         <iframe
      src="SelexHybrid/SelexRISK_Hybrid HAZOP.html"
      width="100%"
      height="800px"
      style={{ border: "none" }}
      title="HTML Page"
    />
    </div>
  )
}

export default SelexHybrid